// https://stamps.atlassian.net/wiki/spaces/PRODREQ/pages/681378524/Mobile+App+-+Common+Extra+Services`
export default Object.freeze({
	AdultSignature: 'adult_signature',
	DirectSignature: 'direct_signature',
	DeliveryConfirmationMailed: 'delivery_confirmation_mailed',
	None: 'none',
	Signature: 'signature',
	Tracking: 'tracking',
});
